import { useEffect, useState } from "react";

// Bracket d'une catégorie, SANS authentification — GET /api/finals/:category
// est volontairement public (voir l'en-tête de finals.js), exactement ce
// qu'il faut ici puisqu'une source navigateur OBS n'envoie aucun jeton.
// Poll rapide par défaut (ces pages tournent en continu à l'écran pendant
// le live — la fraîcheur prime sur l'économie de requêtes).
export function useStreamBracket(category, pollMs = 1500) {
    const [bracket, setBracket] = useState(null);

    useEffect(() => {
        if (!category) {
            setBracket(null);
            return;
        }
        let cancelled = false;
        const load = () => {
            fetch(`/api/finals/${encodeURIComponent(category)}`)
                .then((r) => r.json())
                .then((data) => {
                    if (!cancelled) setBracket(data && data.rounds ? data : null);
                })
                .catch(() => {
                    /* silencieux : une page overlay ne doit jamais planter à l'écran */
                });
        };
        load();
        const timer = setInterval(load, pollMs);
        return () => {
            cancelled = true;
            clearInterval(timer);
        };
    }, [category, pollMs]);

    return bracket;
}
